import { smartCompare } from '~/clientUtils/sortingUtils';
import { StandAdminUserVote } from '~/definitions/report';

const sortUserVotes = (data: StandAdminUserVote[]): StandAdminUserVote[] => {
    if (!data) return [];

    return data.map((item) => ({
        ...item,
        results: item.results?.slice().sort((a, b) => {
            const t1 = new Date(a.ts).getTime();
            const t2 = new Date(b.ts).getTime();

            if (t1 !== t2) {
                return t1 - t2; // Sort by ts ascending
            }

            // If same ts, sort by user_id ascending
            return smartCompare(a.user_id, b.user_id);
        }),
    }));
};

export default sortUserVotes;
